class Store {
	constructor(type) {
		if (!this.storageAvailable(type)) {
			console.log('该浏览器不支持本地存储')
		}
	}
	getItem(key) {
		let str = this.storage.getItem(key)
		if (str) {
			try {
				let obj = JSON.parse(str)
				/*通过检测是否是特定的数据格式来判断是否是通过这个类存储的数据*/
				if (obj.value && obj.updateTime && (typeof obj.expire != 'undefined')) {
					if (Date.now() - obj.updateTime < obj.expire) {
						return obj.value
					} else {
						this.storage.removeItem(key)
						return null
					}
				} else {
					return obj
				}
			} catch (e) {
				/*非JSON格式的字符串直接返回（非严格判断）*/
				return str
			}
		}
		return null
	}
	/*有效期默认是1天*/
	setItem(key, value, expire = 0) {
		this.storage.setItem(key, JSON.stringify({
			value: value,
			updateTime: Date.now(),
			expire: expire
		}))
	}
	storageAvailable(type) {
		var storage
		try {
			this.storage = window[type]
			var x = '__storage_test__'
			storage.setItem(x, x)
			storage.removeItem(x)
			return true
		} catch (e) {
			return e instanceof DOMException && (
				/*everything except Firefox(22), Firefox(1014)*/
				e.code === 22 || e.code === 1014 ||
				/*test name field too, because code might not be present*/
				/*everything except Firefox(QuotaExceededError), Firefox(NS_ERROR_DOM_QUOTA_REACHED)*/
				e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
			) && (storage && storage.length !== 0) /*acknowledge QuotaExceededError only if there's something already stored*/
		}
	}
}
/*MDN中cookie的小小包装*/
class DocCookie {
	constructor(){

	}
	getItem(key){
		let reg = new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$")
		return decodeURIComponent(document.cookie.replace(reg, "$1")) || null
	}
	setItem(key, value, end, path, domain, secure){
		if(!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)){
			return false
		}
		let expires = ''
		if(end){
			switch(end.constructor){
				case Number: {
					expires = end === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + end
					break
				}
				case String: {
					expires = "expires=" + end
					break
				}
				case Date: {
					expires = "; expires=" + end.toUTCString()
					break
				}
			}
		}
		document.cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + expires + (domain ? "; domain=" + domain : "") + (path ? "; path=" + path : "") + (secure ? "; secure=" + secure : "")
		return true
	}
	removeItem(key, path, domain){
		if(key || !this.hasItem(key)){
			return false
		}
		document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : "") + (path ? "; path=" + path : "")
		return true
	}
	hasItem(key){
		let reg = new RegExp("(?:^|;\\s*)" + encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") + "\\s\\=")
		return reg.test(document.cookie)
	}
}
export {Store, DocCookie}

export default new Store('localStorage')
